import * as v2 from '@/core/services/api/v2';

/**
 * Os mapas de pesca.
 *
 * Vêm de `GET /api/catalogo/map`, a mesma vitrine que serve vara, barco, isca e
 * casa. O Strapi tinha `/api/maps?populate=*`, que trazia a entidade inteira com
 * as relações; aqui vem só o que a tela precisa para listar e dizer o que falta
 * para liberar.
 *
 * **Listar não é comprar.** Liberar mapa e trocar de mapa ainda não têm rota no
 * V2 — ver `docs/MIGRACAO-V2.md`. Esta store mostra o que existe; agir sobre
 * isso é o passo seguinte.
 */
export default {
    namespaced: true,
    state: {
        maps: {}
    },
    mutations: {
        SET_MAPS(state, maps) {
            state.maps = maps;
        }
    },
    actions: {
        async fetchMaps({ commit }) {
            const itens = await v2.catalogo('map');

            // A tela indexa por id, e não por posição na lista.
            const mapsData = {};
            itens.forEach((mapa) => {
                mapsData[mapa.id] = {
                    id: mapa.id,
                    name: mapa.name,
                    required: {
                        // `price` é o custo em gold para liberar; 0 = mapa inicial.
                        gold: mapa.price || 0,
                        // O V2 exige **nível de barco**, não um barco específico. O
                        // nome do campo continua `boatId` porque é o que a tela lê;
                        // comparar isso com o id de um barco daria falso desde
                        // sempre, e continua dando — quem consertar mexe nos dois.
                        boatId: mapa.boatLevel || 0,
                        level: mapa.requiredLevel || 0
                    },
                    image: mapa.image || null
                };
            });

            commit('SET_MAPS', mapsData);
            return mapsData;
        }
    }
};
